import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import Barcode  from "react-barcode";

import { Grid, Row, Col, Table } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";
import CustomModal from "../../components/Modal/CustomModal";

import Preloader from "../../views/Preloader/Preloader";
import PerfilModalContent from "./PerfilModalContent";

import { Validate } from '../../funciones/HeaderFunction';
import { NotificacionesValid, AprobarPerfil, NoAprobarPerfil } from '../../funciones/NotificacionesFunction';

let IdUser= "";
let NombreUser= "";
class PefilesPendientes extends Component {
    state = {
        cantNotifValidate: "",
        boton1: {
            icon: "fa fa-times",
            text: "No Aprobar"
        },
        boton2: {
            icon: "fa fa-check",
            text: "Aprobar"
        },
        boton3: {
            icon: "fa fa-plus",
            text: "Más Información"
        },
        solicitudes:[],
        carrerasEst:[],
        contolPais: "",
        openW: false,
        openAccept: false,
        openNoAccept: false,
        contenidoModal: {
            Titulo: "Cargando Datos...",
        },
        Id: "00000",
        idPerfil: "",
        modalAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },
        modalNoAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },

        motivo : {
            text:"",
            mensaje: ""
        }
    }

    constructor (props) {
        super (props);

        Validate  ((resp) => {
          this.setState(resp)
        })

        NotificacionesValid  ((resp) => {
            this.setState({
                solicitudes:resp[0],
                carrerasEst: resp [1]
            })
        })
    }

    cambiaNombre = (valor) => {
        this.setState ({
            contenidoModal: {
                Titulo: valor,
            },
        })
    }

    cambiaId = (valor) => {
        this.setState ({
                Id: valor,
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text: (event.target.value).toUpperCase(),
                mensaje: ""
            },
        });
    };

    showModal = () => {
        const { openW, contenidoModal, idPerfil, Id } = this.state;
        let titulo = () => {
            return(
                <Row>
                    <Col md={8}><div className="text-primary">{contenidoModal.Titulo}</div></Col>
                    <Col md={4} align="right"><Barcode margin= {0} fontSize= {0} width= {1} height= {30} value={Id} /></Col>
                </Row>
            )
        }

        return (
            <CustomModal
                boton1 = ""
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Ok</React.Fragment>}
                large = "large"
                isopen =  {openW}
                titulo = {titulo()}
                contenido = {<PerfilModalContent
                            id={idPerfil}
                            titulo = {(nombre) => { this.cambiaNombre(nombre) }}
                            idUser = {(id) => { this.cambiaId(id) }}/>}       
                funcion1 = ""/>
        );
    }

    modalAccept = () => {
        const { openAccept, modalAcceptBtn1 } = this.state;
        let contenido = () => {
            return(
                <React.Fragment>
                    <div>¿Desea realmente <strong className="text-success">APROBAR</strong> el perfil de <strong>{NombreUser}</strong>?</div>
                    <div style={{fontSize:12}}>Asegúrece de haber revisado <strong>Cuidadosamente</strong> sus datos personales</div>
                </React.Fragment>
            )
        }

        let aceptar = (id) => (e) => {
            this.setState({
                modalAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera"
                }
            })
            
            AprobarPerfil  (id, () => {
                this.setState ({
                    openAccept: false,
                    modalAcceptBtn1: {
                        icon:"fa fa-check",
                        text: "Si"
                    },
                },() => {
                    Validate  ((resp) => {
                        this.setState(resp)
                    })

                    NotificacionesValid  ((resp) => {
                        this.setState({
                            solicitudes:resp[0],
                            carrerasEst: resp [1]
                        })
                    })
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalAcceptBtn1.icon}></i> {modalAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {aceptar(IdUser)}/>
        );
    }

    modalNoAccept = () => {
        const { openNoAccept, modalNoAcceptBtn1, motivo } = this.state;
        let contenido = () => {
            return(
                <React.Fragment>
                    <div>¿Desea realmente <strong className="text-danger"> NO APROBAR</strong> el perfil de <strong>{NombreUser}</strong>?</div>
                    
                    <div className="custom-alert-danger" style={{padding:5}}>
                        <input type="text" value={motivo.text} onChange={this.cambiaValor("motivo")} className="form-control" placeholder="Indica el motivo"/>
                        <span className="text-danger">{motivo.mensaje}</span>
                    </div>
                </React.Fragment>
            )
        }
        
        let noAceptar = (id) => (e) => {
            if ((motivo.text) === "") {
                this.setState({
                    motivo : {
                        text:"",
                        mensaje: "Indica primero el motivo"
                    }
                })
                return null;
            }

            this.setState({
                modalNoAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espere"
                }
            })

            NoAprobarPerfil  (id, motivo.text, () => {
                this.setState ({
                    openNoAccept: false,
                    modalNoAcceptBtn1: {
                        icon:"fa fa-check",
                        text: "Si"
                    },
                    motivo : {
                        text:"",
                        mensaje: ""
                    }
                },() => {
                    Validate  ((resp) => {
                        this.setState(resp)
                    })

                    NotificacionesValid  ((resp) => {
                        this.setState({
                            solicitudes:resp[0],
                            carrerasEst: resp [1]
                        })
                    })
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalNoAcceptBtn1.icon}></i> {modalNoAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openNoAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(IdUser)}
            />
        );
    }

    modalInfo = (id) => (e) => {
        this.setState({
            openW: true,
            openAccept: false,
            openNoAccept: false,
            idPerfil: id
        })
    }

    verModalAccept = (id, nombre) => (e) => {
        IdUser = id;
        NombreUser = nombre;
        this.setState({
            openAccept: true,
            openNoAccept: false,  
            openW: false,  
        })
    }

    verModalNoAccept = (id, nombre) => (e) => {
        IdUser = id;
        NombreUser = nombre;
        this.setState({
            openNoAccept: true,
            openAccept: false,
            openW: false,  
        })
    }

    contenido = () => {
        let { boton1, boton2, boton3, solicitudes, carrerasEst } = this.state;
        let tipoUsu = (tipo) => {
            switch (tipo) {
                case "EST":
                  return ("ESTUDIANTE")
                case "PROF":
                return ("PROFESOR")
                case "DIR":
                return ("DIRECTIVO")
                default:
                    return(<div></div>)
            }
        }

        let dataUser = (text1, valor) => {
            return (
                <React.Fragment>
                    <Col md={3} className="text-muted">
                        {text1}
                    </Col>
                    <Col md={9}>
                        {valor}
                    </Col>
                </React.Fragment>
            );
        }

        let fecha = (data) => {
            let fecha = "N/D"
            if (data === null) return fecha;

            let date = new Date(data)

            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()
            if (day < 10) day = `0${day}`
            if (month < 10) month = `0${month}`

            fecha = `${day}/${month}/${year}`
            return fecha
        }

        let quitaNull = (campo) => {
            if(campo === null || campo === "") return "";
            return campo;
        }

        let semestre = (id, tipo) => {
            const resultado = carrerasEst.find( (estudiante) => estudiante.User_Id === id );
            if(tipo === "EST")return(
                <div><strong>{resultado.Carrera}</strong></div>
            )
            return null;
        }

        let clase = (tipo) => {
            switch (tipo) {
                case "EST":
                  return ("text-primary")
                case "PROF":
                return ("text-danger")
                case "DIR":
                return ("text-warning")
                default:
                    return(<div></div>)
            }
        }

        const styles = {
            padding: 5, fontSize: 12
        }
        const stylesMap = {
            padding: 7, fontSize:10
        }

        let solicitudesPeriles = () => {
            return (
                solicitudes.map(option => (
                    <tr key={option.id}>
                        <td align="center"style={stylesMap}>{`${option.nacionalidad} ${option.ci}`}</td>
                        <td style={stylesMap}>{`${quitaNull(option.nombre_1)} ${quitaNull(option.nombre_2)} ${quitaNull(option.apellido_1)} ${quitaNull(option.apellido_2)}`}</td>
                        <td align="center" style={stylesMap} className={clase(option.t_name)}>{tipoUsu(option.t_name)}</td>
                        {/* <td align="center" style={stylesMap}>{semestre(option.id, option.t_name)}</td> */}
                        <td align="center" style={stylesMap}>
                            <div className="btn-group">
                                <button onClick={this.verModalNoAccept(option.id, `${quitaNull(option.nombre_1)} ${quitaNull(option.nombre_2)} ${quitaNull(option.apellido_1)} ${quitaNull(option.apellido_2)}`)} className="btn btn-danger btn-sm" style={{borderWidth: 1}} title={boton1.text}><i className={boton1.icon}></i></button>
                                <button onClick={this.verModalAccept(option.id, `${quitaNull(option.nombre_1)} ${quitaNull(option.nombre_2)} ${quitaNull(option.apellido_1)} ${quitaNull(option.apellido_2)}`)} className="btn btn-success btn-sm" style={{borderWidth: 1}} title={boton2.text}><i className={boton2.icon}></i></button>
                                <button onClick={this.modalInfo(option.id)} className="btn btn-primary btn-sm" style={{borderWidth: 1}} title={boton3.text}><i className={boton3.icon}></i></button>
                            </div>
                        </td>
                    </tr>
                ))
            )

        }

        return (
            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                <Table striped hover bordered>
                    <tbody>
                        <tr className="custon-back-color">
                            <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                            <td width="50%" style={styles}><strong>Usuario</strong></td>
                            <td align="center" width="10%" style={styles}><strong>Tipo</strong></td>
                            {/* <td align="center" width="15%" style={styles}><strong>Carrera</strong></td> */}
                            <td align="center" width="29%" style={styles}><strong>Acciones</strong></td>
                        </tr>
                        {solicitudesPeriles()}
                    </tbody>
                </Table>
            </div>
        )
        
        
        /* return (
            solicitudes.map(option => (
                <div className="card card-user" key={option.id} id={option.id} style={{boxShadow: "1px 1px 2px #CCC", backgroundColor:"#FFF"}}>
                    <div className="content" style={{minHeight:0, lineHeight:2}} align="justify">
                        <Row className={clase(option.t_name)}>
                            <Col md={4}>
                                <strong>{tipoUsu(option.t_name)}</strong>
                            </Col>
                            <Col md={8} align="right">
                                {semestre(option.id, option.t_name)}
                            </Col>
                        </Row>
                        <Row>
                            {dataUser ("Cédula:", `${option.nacionalidad} ${option.ci}`)}
                            {dataUser ("Nombre Completo:", `${quitaNull(option.nombre_1)} ${quitaNull(option.nombre_2)} ${quitaNull(option.apellido_1)} ${quitaNull(option.apellido_2)}`)}
                            {dataUser ("Lugar de Nac.:", `${option.pais_name} | ${option.estado_name} | ${option.ciudad_name} | ${option.municipio_name} | ${option.parroquia_name}`)}
                            {dataUser ("Fecha:", fecha(option.f_nac))}
                        </Row>
                        <hr/>
                        <div align="right" style={{marginTop: 10}}>
                            <div style={{marginTop:2}}>
                                <button type="button" onClick={this.verModalNoAccept(option.id, `${quitaNull(option.nombre_1)} ${quitaNull(option.nombre_2)} ${quitaNull(option.apellido_1)} ${quitaNull(option.apellido_2)}`)} className="btn btn-danger btn-sm" style={{borderWidth: 1, marginRight:10}} title={boton1.text}><i className={boton1.icon}></i> {boton1.text}</button>
                                <button type="button" onClick={this.verModalAccept(option.id, `${quitaNull(option.nombre_1)} ${quitaNull(option.nombre_2)} ${quitaNull(option.apellido_1)} ${quitaNull(option.apellido_2)}`)} className="btn btn-success btn-sm" style={{borderWidth: 1, marginRight:10}} title={boton2.text}><i className={boton2.icon}></i> {boton2.text}</button>
                                <button type="button" onClick={this.modalInfo(option.id)} className="btn btn-primary btn-sm" style={{borderWidth: 1}} title={boton3.text}><i className={boton3.icon}></i> {boton3.text}</button>
                            </div>
                        </div>
                    </div>
                </div>
            ))
        ); */
    }

    ayuda = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Acerca de la aprobación de los perfiles</strong>
                    </Col>
                    <Col md={2} align="center" style={{fontSize:12}}>
                        <button type="button" className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-times"></i></button>
                    </Col>
                    <Col md={10} align="justify">
                        Este botón permite <strong>NO APROBAR</strong> el perfil del usuario.
                        Esto impide que el usuario acceda a las funciones del sistema.
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={2} align="center" style={{fontSize:12}}>
                        <button type="button" className="btn btn-success btn-xs" style={{borderWidth: 1}}><i className="fa fa-check"></i></button>
                    </Col>
                    <Col md={10} align="justify">
                        Este botón permite <strong>APROBAR</strong> el perfil del usuario.
                        Una vez que el estudiante tenga su perfil aprobado podrá ingresar a las funciones del sistema.
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={2} align="center" style={{fontSize:12}}>
                        <button type="button" className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-plus"></i></button>
                    </Col>
                    <Col md={10} align="justify">
                        Este botón permite ver la información del usuario de una manera mas detallada.
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={3} align="right" style={{fontSize:12}}>
                        <div className= "custom-alert-danger" align="center">Profesor</div>
                    </Col>
                    <Col md={9} align="justify">
                        Este es el color de los perfiles de los <strong>Profesores</strong>.
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={3} align="right" style={{fontSize:12}}>
                        <div className= "custom-alert-success" align="center">Profesor</div>
                    </Col>
                    <Col md={9} align="justify">
                        Este es el color de los perfiles de los <strong>Estudiantes</strong>.
                        <div>En este caso podrás ver en al lado derecho de la franja de color  <strong style={{color:"#326432"}}>Verde</strong> el Semestre selecionado
                            por el estudiante.
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    render() { 
        if (this.state.cantNotifValidate === "") {
            return(<Preloader/>) 
        }else if (this.state.cantNotifValidate === 0) {
            return (<Redirect to="/noticias" />)
        }else if (this.state.cantNotifValidate > 0) {
            return (
                <React.Fragment>
                    <div className="content">
                        <Grid fluid>
                            <Row>
                                <Col md={8}>
                                    <div className="custom-alert-info" style={{marginBottom:15}}>
                                        <div className="title" style={{fontSize:18}}>
                                            Perfiles por Aprobar
                                            <p style={{color:"#000", fontSize:10}}>{`Tienes (${this.state.cantNotifValidate}) perfile(s) por aprobar`}</p>
                                        </div>
                                    </div>
                                    {this.contenido()}
                                </Col>
                                <Col md={4}>
                                    <CustomCard
                                        styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                        title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                        category={<span style={{color: "#fff"}}>Aprobar Perfiles</span>}
                                        color="#a80012"
                                        content={this.ayuda()}
                                    />
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                    {this.showModal()}
                    {this.modalAccept()}
                    {this.modalNoAccept()}
                </React.Fragment>
            );
        }
    }
}
 
export default PefilesPendientes;



// WEBPACK FOOTER //
// ./src/views/Perfil/PefilesPendientes.jsx